import { initVideoTracking } from "../../ui";

import "./discover-section.scss";

const getVideo$ = () => document.querySelector(".js-jiffytransfers-landing-v2-discover-video");

const getFaqQuestions$ = () =>
  document.querySelectorAll(".js-jiffytransfers-landing-v2-discover-faq-link");

const SHOWN_CLASS = "jiffytransfers-landing-v2-discover-section__discover-faq-item--shown";

const hideAllQuestions = () => {
  getFaqQuestions$().forEach(faqQuestion => {
    faqQuestion.parentElement?.classList.remove(SHOWN_CLASS);
  });
};

document.addEventListener("DOMContentLoaded", () => {
  initVideoTracking(getVideo$(), "Discover The Game Changing Power of Jiffy Transfers");

  getFaqQuestions$().forEach(faqQuestion => {
    faqQuestion.addEventListener("click", () => {
      hideAllQuestions();
      faqQuestion.parentElement?.classList.toggle(SHOWN_CLASS);
    });
  });
});
